import { useQuery } from "react-query";
import axios from "infra/http";
import { AreaComumUnidadeBloqueadaDetalhe } from "../typings";

function useDetalheBloqueioUnidade(id?: string) {
  return useQuery(
    `/v1/bloqueio-reserva/${id}`,
    async () => {
      const { data } = await axios.get<
        AreaComumUnidadeBloqueadaDetalhe
      >(`/v1/bloqueio-reserva/${id}`);

      return data;
    },
    {
      enabled: !!id,
    }
  );
}

export default useDetalheBloqueioUnidade;
